/**
 * UranIA PA — `/admin/cutover-gates` (redirect a `/admin/conformita/gate`).
 *
 * Fusione A.4.4 (Riordino della mappa delle rotte §4): il contenuto vive
 * ora su `/admin/conformita/gate`
 * (`routes/admin/conformita/gate/index.tsx`). Questa rotta resta solo
 * come redirect.
 */

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as AmministrazioneSegmentRoute } from '../../_amministrazione.tsx';

export const Route = createRoute({
  getParentRoute: () => AmministrazioneSegmentRoute,
  path: '/admin/cutover-gates',
  beforeLoad: () => {
    throw redirect({ to: '/admin/conformita/gate', replace: true });
  },
});
